/* eslint-disable no-undef */

const players = Array.from(document.querySelectorAll('.js-player')).map(
  (p) =>
    new Plyr(p, {
      controls: ['play', 'current-time', 'progress'],
    })
);

//$(".user-loader").addClass("hide");

window.onload = async () => {
  const path = await Wized.data.get('n.path');
  var sessionMediaComplete = false;

  if (path === '/dashboard/mit-report') {
    Wized.request.await('Get MIT Study PPT', (response) => {
      function delayedAction() {
        window.Webflow && window.Webflow.destroy();
        window.Webflow && window.Webflow.ready();
        window.Webflow && window.Webflow.require('ix2').init();
        document.dispatchEvent(new Event('readystatechange'));
        iframeSetup();
      }
      setTimeout(delayedAction, 100);
    });
  }
  // Define session logic
  if (path === '/fitness/sessions' || path === '/sleep/sessions') {
    // Hide session until startSession is clicked
    const sessionWindow = $('[wized=sessionWindow]');
    $(sessionWindow).addClass('hide');

    async function updateNav(session) {
      //const currentSession = await Wized.data.get("v.currentsession");
    }

    // Define session step compelte buttons
    $('[wized=completeSessionStep]').each(function () {
      $(this).on('click', async function () {
        // Get currentSession
        const currentSession = await Wized.data.get('v.currentsession');
        const currentPart = await Wized.data.get('v.currentpart');
        currentSession[currentPart] = true;
        await Wized.data.setVariable('currentsession', currentSession);
        var triggerButton = $(this).parent().parent().siblings().find('a').end();
        $(triggerButton).addClass('is-complete');
      });
    });

    // Set continue button on sessions
    var start = $('[wized=startSession]');
    var next = $('#continue');
    var back = $('#back');
    var confirmOne = $('[wized=sessionConfirm1]');
    var confirmTwo = $('[wized=sessionConfirm2]');
    var confirmThree = $('[wized=sessionConfirm3]');
    $(start).on('click', function () {
      $(sessionWindow).removeClass('hide');
      $(next).addClass('hide');
    });

    $(next).on('click', async function () {
      $('.w-tab-link[aria-selected=true]').next('.w-tab-link').click();
      const currentSession = await Wized.data.get('v.currentsession');
      const currentStep = await Wized.data.get('v.sessionstep');
      if (currentStep === 1) {
        currentSession[3.3] ? $(next).removeClass('hide') : $(next).addClass('hide');
      }
    });

    $(back).on('click', async function () {
      $('.w-tab-link[aria-selected=true]').prev('.w-tab-link').click();
      const currentSession = await Wized.data.get('v.currentsession');
      const currentStep = await Wized.data.get('v.sessionstep');
      if (currentStep === 1) {
        currentSession[3.2] ? $(next).removeClass('hide') : $(next).addClass('hide');
      }
    });

    // Define session confirm buttons
    $(confirmOne).on('click', async function () {
      $(this).addClass('checked');
      $(next).removeClass('hide');
      // Get currentSession
      const currentSession = await Wized.data.get('v.currentsession');
      currentSession['3.2'] = true;
      await Wized.data.setVariable('currentsession', currentSession);
    });
    $(confirmTwo).on('click', async function () {
      $(this).addClass('checked');
      $(next).removeClass('hide');
      // Get currentSession
      const currentSession = await Wized.data.get('v.currentsession');
      currentSession['3.3'] = true;
      await Wized.data.setVariable('currentsession', currentSession);
    });
    $(confirmThree).on('click', async function () {
      $(this).addClass('checked');
      $(next).removeClass('hide');
      // Get currentSession
      const currentSession = await Wized.data.get('v.currentsession');
      currentSession['3.5'] = true;
      await Wized.data.setVariable('currentsession', currentSession);
    });
  }

  if (path === '/sleep/sessions') {
    // Define variables
    var sleep_current = $('[wized=sleep_overview]');
    var sleep_currentSelector = $('[wized=sleep_preparation]');
    var sleep_continueButton = $('[wized=sleep_continue]');
    var sleep_continueSelectorButton = $('[wized=sleep_selector_continue]');
    var sleep_continueSelectorButtonWrapper = $('[wized=sleep_selector_continue_wrapper]');
    var sleep_startSession = $('[wized=sleep_start_session]');
    var sleep_sessionOverlay = $('[wized=sleep_overlay]');
    var sleep_prepRemoved = false;
    var sleep_selected = null;
    var sleep_session = {
      preparation: {
        name: 'Preparation',
        active: true,
        guide: 'Male',
        category: null,
        thumbnail: null,
        title: null,
        tracks: null,
      },
      transition: {
        name: 'Transition',
        active: true,
        category: null,
        thumbnail: null,
        title: null,
        tracks: null,
      },
      maintenance: {
        name: 'Maintenance',
        active: true,
        category: null,
        thumbnail: null,
        title: null,
        tracks: null,
        completed: null,
      },
    };

    const sessionWindow = document.getElementById('session');

    function checkPrep() {
      // Remove prep DOM if inactive
      if (!sleep_session.preparation.active && !sleep_prepRemoved) {
        $('[wized=sleep_preparation_select]').remove();
        $('[wized=sleep_preparation]').remove();
        $('[wized=sleep_preparation_item]').remove();
        sleep_currentSelector = $('[wized=sleep_transition]');
        sleep_currentSelector.removeClass('hide');
        //sleep_currentSelector.addClass("is-active");
        $('.sleep-selection_component').children(':first').children(':first').addClass('is-active');
        sleep_prepRemoved = true;
      }
    }

    function setActiveSelector() {
      // Set active Selector
      var selected = $('.sleep-selection_component').children().children('.is-active');
      $(selected).removeClass('is-active');
      $(selected).parent().next().children(':first').addClass('is-active');
    }

    function highlightTrack(e) {
      // Highlight selected track
      if (!$(e).hasClass('is-active')) {
        sleep_continueSelectorButtonWrapper.removeClass('hide');
        $(e).addClass('is-active');
        $(sleep_selected).removeClass('is-active');
        sleep_selected = e;
      }
    }

    // Set continue button actions
    $(sleep_continueButton).on('click', function () {
      sleep_current.addClass('hide');
      sleep_current.next().removeClass('hide');
      sessionWindow.scrollIntoView({ behavior: 'smooth' });
      sleep_current = sleep_current.next();
      sleep_continueSelectorButtonWrapper.addClass('hide');
      checkPrep();
    });

    $(sleep_continueSelectorButton).on('click', function () {
      sleep_continueSelectorButtonWrapper.addClass('hide');
      sleep_currentSelector.addClass('hide');
      sleep_currentSelector.next().removeClass('hide');
      sessionWindow.scrollIntoView({ behavior: 'smooth' });
      sleep_currentSelector = sleep_currentSelector.next();
      setActiveSelector();
    });

    // Toggle component
    var sleep_prepToggle = $('[wized=sleep_prep_toggle]');
    var sleep_prepToggleOptions = {
      preview: new Audio(),
      toggle: true,
      toggleElement: $('[wized=sleep_prep_options]'),
      activeElement: $('[wized=sleep_prep_toggle_on]'),
      inactiveElement: $('[wized=sleep_prep_toggle_off]'),
      guide: 'Male',
      maleElement: $('[wized=sleep_prep_guide_james]'),
      malePreview:
        'https://cdn.soundbrilliance.com/Sleep%201.1%20Finalized%20Audio/Full/james.wav',
      femaleElement: $('[wized=sleep_prep_guide_sarah]'),
      femalePreview:
        'https://cdn.soundbrilliance.com/Sleep%201.1%20Finalized%20Audio/Full/sarah.wav',
      messageElement: $('[wized=sleep_prep_text]'),
      activeMsg:
        'By leaving Preparation on, you will begin your Sleep Protocol with a guided priming exercise.',
      inactiveMsg:
        'By turning Preparation off, you will be skipping the guided priming exercise and beginning directly with the Sleep Transition phase.',
    };
    if (!sleep_prepToggleOptions.toggle) {
      sleep_prepToggle.hide();
    }

    var prepObj = sleep_prepToggleOptions;

    $(sleep_prepToggle).on('click', async function () {
      if (sleep_session.preparation.active) {
        sleep_session.preparation.active = false;
        prepObj.inactiveElement.removeClass('hide');
        prepObj.activeElement.addClass('hide');
        prepObj.toggleElement.addClass('hide');
        prepObj.messageElement.html(prepObj.inactiveMsg);
      } else {
        sleep_session.preparation.active = true;
        prepObj.inactiveElement.addClass('hide');
        prepObj.activeElement.removeClass('hide');
        prepObj.toggleElement.removeClass('hide');
        prepObj.messageElement.html(prepObj.activeMsg);
      }
    });

    $(prepObj.maleElement).on('click', async function () {
      prepObj.preview.src = prepObj.malePreview;
      prepObj.preview.load();
      prepObj.preview.play();
      prepObj.guide = 'Male';
      sleep_session.preparation.guide = prepObj.guide;
      $(prepObj.maleElement).children(':first').addClass('is-active');
      $(prepObj.femaleElement).children(':first').removeClass('is-active');
    });

    $(prepObj.femaleElement).on('click', async function () {
      prepObj.preview.src = prepObj.femalePreview;
      prepObj.preview.load();
      prepObj.preview.play();
      prepObj.guide = 'Female';
      sleep_session.preparation.guide = prepObj.guide;
      $(prepObj.femaleElement).children(':first').addClass('is-active');
      $(prepObj.maleElement).children(':first').removeClass('is-active');
    });

    // Preparation
    $('[wized=sleep_preparation]')
      .find('.audio-single-playlist_component')
      .each(function () {
        $(this).on('click', function () {
          highlightTrack($(this));
          // Set guide track
          if (sleep_session.preparation.guide == 'Male') {
            sleep_session.preparation.tracks = JSON.parse($(this).attr('guidance-male-source'));
          } else if (sleep_session.preparation.guide == 'Female') {
            sleep_session.preparation.tracks = JSON.parse($(this).attr('guidance-female-source'));
          } else {
            sleep_session.preparation.tracks = JSON.parse($(this).attr('source'));
          }
          // Set values
          sleep_session.preparation.title = $(this).find('[title]').first().text();
          sleep_session.preparation.thumbnail = $(this).find('[thumbnail]').first().attr('src');
          sleep_session.preparation.category = $(this).attr('category');
          // Set thumbnails
          $('[wized=sleep_preparation_thumbnail]').each(function () {
            $(this).attr('src', sleep_session.preparation.thumbnail);
            $(this).removeClass('hide');
          });
        });
      });

    // Transition
    $('[wized=sleep_transition]')
      .find('.audio-single-playlist_component')
      .each(function () {
        $(this).on('click', function () {
          highlightTrack($(this));
          // Set values
          sleep_session.transition.tracks = JSON.parse($(this).attr('source'));
          sleep_session.transition.title = $(this).find('[title]').first().text();
          sleep_session.transition.thumbnail = $(this).find('[thumbnail]').first().attr('src');
          sleep_session.transition.category = $(this).attr('category');
          // Set thumbnails
          $('[wized=sleep_transition_thumbnail]').each(function () {
            $(this).attr('src', sleep_session.transition.thumbnail);
            $(this).removeClass('hide');
          });
        });
      });

    // Maintenance
    $('[wized=sleep_maintenance]')
      .find('.audio-single-playlist_component')
      .each(function () {
        $(this).on('click', function () {
          highlightTrack($(this));
          // Set values
          sleep_session.maintenance.tracks = JSON.parse($(this).attr('source'));
          sleep_session.maintenance.title = $(this).find('[title]').first().text();
          sleep_session.maintenance.thumbnail = $(this).find('[thumbnail]').first().attr('src');
          sleep_session.maintenance.category = $(this).attr('category');
          // Set thumbnails
          $('[wized=sleep_maintenance_thumbnail]').each(function () {
            $(this).attr('src', sleep_session.maintenance.thumbnail);
            $(this).removeClass('hide');
          });
        });
      });

    // Session player

    function startSleepSession() {
      // Create audio
      //var sleep_audio = new Audio();
      //var sleep_audio_alt = new Audio();
      const audioContext = new (window.AudioContext || window.webkitAudioContext)();
      const gainNodes = [audioContext.createGain(), audioContext.createGain()];
      gainNodes.forEach((gain) => gain.gain.setValueAtTime(0, audioContext.currentTime));

      function createAudioElement(src) {
        const audio = new Audio(src);
        const track = audioContext.createMediaElementSource(audio);
        return { audio, track };
      }

      const audioElements = [createAudioElement(''), createAudioElement('')];

      //const audioElements = [new Audio(), new Audio()];
      //audioElements.forEach(audio => audio.volume = 0); // Initially set volume to 0

      var sleep_sessionProgress = $('[wized=sleep_session_progress]');
      var sleep_sessionTime = $('[wized=sleep_session_time]');
      var sleep_sessionThumbnail = $('[wized=sleep_session_thumbnail]');
      var sleep_sessionStage = $('[wized=sleep_session_stage]');
      var sleep_sessionStageDescription = $('[wized=sleep_session_stage_description]');
      var sleep_sessionContent = $('[wized=sleep_session_content]');
      var sleep_sessionPlay = $('[wized=sleep_session_play]');
      var sleep_sessionPause = $('[wized=sleep_session_pause]');
      var sleep_sessionComplete = $('[wized=sleep_session_complete]');
      // Filter the sleep_session object to include only items where active is true
      var sleep_sessionPlaylist = Object.keys(sleep_session).reduce((acc, key) => {
        if (sleep_session[key].active === true) {
          acc[key] = sleep_session[key];
        }
        return acc;
      }, {});
      // Get keys of object
      var keys = Object.keys(sleep_sessionPlaylist);
      var sleep_currentStage = 0;
      var sleep_currentTrack = 0;
      var sleep_currentTrackTotal = 0;
      var sleep_complete = false;
      let currentAudioIndex = 0;
      const crossfadeDuration = 10; // seconds

      async function completeSleepSession() {
        sleep_session.maintenance.completed = Date.now();
        await Wized.data.setVariable('session_metadata', sleep_session);
        await Wized.request.execute('Complete Session'); // Trigger request
        // Display completed message
        $(sleep_sessionComplete).removeClass('hide');
        $('.session-player_wrapper').addClass('hide');
      }

      function fadeInX(gainNode, duration, delay) {
        let fadeDelay = 0;
        if (delay) {
          duration = duration / 2;
          fadeDelay = duration * 1000;
        }
        setTimeout(() => {
          gainNode.gain.cancelScheduledValues(audioContext.currentTime);
          gainNode.gain.setValueAtTime(gainNode.gain.value, audioContext.currentTime);
          gainNode.gain.linearRampToValueAtTime(1, audioContext.currentTime + duration);
        }, fadeDelay);
      }

      function fadeIn(audio, duration, delay) {
        let volume = 0;
        let fadeDelay = 0;
        if (delay) {
          duration = duration / 2;
          fadeDelay = duration * 1000;
        }
        const step = 1 / (duration * 10); // Increase volume in small steps
        setTimeout(() => {
          const interval = setInterval(() => {
            volume = Math.min(volume + step, 1);
            audio.volume = volume;
            if (volume === 1) clearInterval(interval);
          }, 100);
        }, fadeDelay);
      }

      function fadeOutX(gainNode, duration) {
        gainNode.gain.cancelScheduledValues(audioContext.currentTime);
        gainNode.gain.setValueAtTime(gainNode.gain.value, audioContext.currentTime);
        gainNode.gain.linearRampToValueAtTime(0, audioContext.currentTime + duration);
      }

      function fadeOut(audio, duration) {
        let volume = 1;
        const step = 1 / (duration * 10); // Decrease volume in small steps

        const interval = setInterval(() => {
          volume = Math.max(volume - step, 0);
          audio.volume = volume;
          if (volume === 0) {
            audio.pause();
            clearInterval(interval);
          }
        }, 100);
      }

      function loadAudio(audioElement, src) {
        return new Promise((resolve) => {
          audioElement.audio.src = src;
          audioElement.audio.crossOrigin = 'anonymous';
          audioElement.audio.load();
          audioElement.audio.addEventListener(
            'loadedmetadata',
            () => resolve(audioElement.audio),
            {}
          );
        });
      }

      async function playTrack(stage, track, start) {
        if (sleep_complete) {
          completeSleepSession();
        } else {
          // Get total tracks for current stage
          sleep_currentTrackTotal = sleep_sessionPlaylist[keys[stage]].tracks.length - 1;
          // Set values
          $(sleep_sessionProgress).css('width', '0%');
          $(sleep_sessionTime).text('Loading');
          $(sleep_sessionThumbnail).attr('src', sleep_sessionPlaylist[keys[stage]].thumbnail);
          $(sleep_sessionStage).text(sleep_sessionPlaylist[keys[stage]].name);
          $(sleep_sessionStageDescription).text('Stage ' + (stage + 1) + ' of ' + keys.length);
          var artist = sleep_sessionPlaylist[keys[stage]].tracks[track].artist;
          var title = sleep_sessionPlaylist[keys[stage]].tracks[track].title;
          // Check if artist is not an empty string
          var artistText = artist !== '' ? artist + ', ' : '';
          // Combine artist (with comma if not empty) and title
          var combinedText = artistText + title;
          // Set the text content
          $(sleep_sessionContent).text(combinedText);

          // Load and play
          const currentAudioElement = audioElements[currentAudioIndex];
          const nextAudioIndex = (currentAudioIndex + 1) % audioElements.length;
          const nextAudioElement = audioElements[nextAudioIndex];

          // If inital load
          if (start) {
            await loadAudio(
              currentAudioElement,
              sleep_sessionPlaylist[keys[stage]].tracks[track].src
            );
            currentAudioElement.track
              .connect(gainNodes[currentAudioIndex])
              .connect(audioContext.destination);
            currentAudioElement.audio.play();
            gainNodes[currentAudioIndex].gain.value = 0;
            fadeInX(gainNodes[currentAudioIndex], crossfadeDuration, false);
          }

          // Set play button
          $(sleep_sessionPlay).on('click', function () {
            currentAudioElement.audio.pause();
            $(sleep_sessionPause).removeClass('hide');
            $(sleep_sessionPlay).addClass('hide');
          });

          // Set pause button
          $(sleep_sessionPause).on('click', function () {
            currentAudioElement.audio.play();
            $(sleep_sessionPlay).removeClass('hide');
            $(sleep_sessionPause).addClass('hide');
          });

          // Add end listener
          currentAudioElement.audio.addEventListener('ended', function onEnding() {
            currentAudioElement.audio.removeEventListener('ended', onEnding);
            playTrack(sleep_currentStage, sleep_currentTrack, false);
          });

          // Add buffering
          currentAudioElement.audio.addEventListener('waiting', function () {
            $(sleep_sessionTime).text('Buffering');
          });

          // Show progress
          currentAudioElement.audio.addEventListener('timeupdate', function onProgressTimeUpdate() {
            // Get the total duration of the audio
            var duration = currentAudioElement.audio.duration;
            // Get the current time of the audio
            var currentTime = currentAudioElement.audio.currentTime;
            // Get the percentage
            var percentage = (currentTime / duration) * 100;
            // Calculate the time remaining
            var timeRemaining = duration - currentTime;
            // Format the time remaining as hours:minutes:seconds
            var hours = Math.floor(timeRemaining / 3600);
            var minutes = Math.floor((timeRemaining % 3600) / 60);
            var seconds = Math.floor(timeRemaining % 60);
            // Output the formatted time remaining
            var formattedTimeRemaining =
              hours.toString().padStart(2, '0') +
              ':' +
              minutes.toString().padStart(2, '0') +
              ':' +
              seconds.toString().padStart(2, '0');
            $(sleep_sessionTime).text(formattedTimeRemaining);
            $(sleep_sessionProgress).css('width', percentage + '%');
            if (percentage == 100) {
              currentAudioElement.audio.removeEventListener('timeupdate', onProgressTimeUpdate);
            }
          });

          // Set next stage and track
          if (track < sleep_currentTrackTotal) {
            sleep_currentTrack++;
            await loadAudio(
              nextAudioElement,
              sleep_sessionPlaylist[keys[stage]].tracks[sleep_currentTrack].src
            );
            nextAudioElement.track
              .connect(gainNodes[nextAudioIndex])
              .connect(audioContext.destination);
          } else if (stage < keys.length - 1) {
            sleep_currentStage++;
            sleep_currentTrack = 0;
            await loadAudio(
              nextAudioElement,
              sleep_sessionPlaylist[keys[sleep_currentStage]].tracks[sleep_currentTrack].src
            );
            nextAudioElement.track
              .connect(gainNodes[nextAudioIndex])
              .connect(audioContext.destination);
          } else {
            sleep_complete = true;
          }
          // Set crossfades
          currentAudioElement.audio.addEventListener('timeupdate', function onTimeUpdate() {
            const crossfadeStart = currentAudioElement.audio.duration - crossfadeDuration;
            if (currentAudioElement.audio.currentTime >= crossfadeStart) {
              currentAudioElement.audio.removeEventListener('timeupdate', onTimeUpdate);
              if (!sleep_complete) {
                nextAudioElement.audio.play();
                fadeInX(gainNodes[nextAudioIndex], crossfadeDuration, true);
                fadeOutX(gainNodes[currentAudioIndex], crossfadeDuration);
                currentAudioIndex = nextAudioIndex;
                nextAudioElement.audio.addEventListener('timeupdate', function onNextTimeUpdate() {
                  if (nextAudioElement.audio.currentTime >= crossfadeStart) {
                    nextAudioElement.audio.removeEventListener('timeupdate', onNextTimeUpdate);
                  }
                });
              } else {
                // End fade
                fadeOutX(gainNodes[currentAudioIndex], crossfadeDuration);
              }
            }
          });
        }
      }
      // Set inital track
      playTrack(sleep_currentStage, sleep_currentTrack, true);
    }
    // Set overlay player
    $(sleep_startSession).on('click', async function () {
      sleep_current.addClass('hide');
      sleep_sessionOverlay.css('display', 'flex');
      sessionWindow.scrollIntoView({ behavior: 'smooth' });
      // Trigger session in database
      await Wized.data.setVariable('session_metadata', sleep_session);
      await Wized.request.execute('Create Session'); // Trigger request

      startSleepSession();
    });
  }
  /*

    $("[wized=startSession]").on("click", function () {
      $("[soundscape=Rain]").attr('src',
        "https://s3.us-west-1.wasabisys.com/dbpublic/Sleep%20Study/soundBrilliance%20Sleep%20Prototype%20(Rain%20Story)%207%20Hz%20-%20Alternate%20Mix%203.wav"
      );

      $("[soundscape=Fireplace]").attr('src',
        "https://s3.us-west-1.wasabisys.com/dbpublic/Sleep%20Study/soundBrilliance%20Sleep%20Prototype%20(Fireplace%20Visualization)%207%20Hz%20-%20Alternate%20Mix%203.wav"
      );

      $("[soundscape=Ocean]").attr('src',
        "https://s3.us-west-1.wasabisys.com/dbpublic/Sleep%20Study/soundBrilliance%20Sleep%20Prototype%20(Ocean%20Visualization)%207%20Hz%20-%20Alternate%20Mix%203.wav"
      );
      //https://soundbrilliance.s3.us-east-2.amazonaws.com/demo-media/sleep/%5BC%5D+Sleep+Prep+Phase+Guidance+Ocean+Visualization+Sample+03.wav
    });

    $("audio").bind("play", async function () {
      var activated = this;
      var soundScape = this.getAttribute("soundScape")
      if ($(this).data('once-played')) return; // Do nothing if data exists.

      var metaData = {
        "soundscape": soundScape
      }
      await Wized.data.setVariable("session_metadata", metaData);

      // Your code here
      await Wized.request.execute('Create Session'); // Trigger request

      // Finally, add a flag.
      $(this).data('once-played', true);

      // Pause other players
      $("audio").each(function () {
        if (this != activated) {
          this.pause();
          this.currentTime = 0;
          $(this).data('once-played', false);
        }
      });
    });

    $("audio").bind("ended", async function () {
      var soundScape = this.getAttribute("soundScape");
      var metaData = {
        "soundscape": soundScape,
        "ended": Date.now()
      }
      await Wized.data.setVariable("session_metadata", metaData);
      await Wized.request.execute('Complete Session'); // Trigger request
    });

  } else {
    $("audio").bind("play", function () {
      var activated = this;
      $("audio").each(function () {
        if (this != activated) this.pause();
      });
    });
  }
  */

  if (path === '/mit/sessions') {
    const sessionEmail = await Wized.data.get('r.3.d.email');
    const token = await Wized.data.get('c.token');
    const sessionWindow = $('[wized=sessionWindow]');
    const preferenceSession = $('[wized=mit_sessionWrapper]');
    const experienceSession = $('[wized=mit_experienceWrapper]');

    // Audio Settings
    //var currentAudioPlayer = null;
    var track = 0;
    var playlist = false;
    var tracks = {};
    var isTrackPlayedLogged = false;

    $(sessionWindow).addClass('hide');

    Wized.request.await('Get MIT Session', (response) => {
      if (token !== undefined || token !== '' || token !== null) {
        $('.user-loader').addClass('hide');
      }
      const sessionStarted = response.data.study[0].current_session_started;
      const sessionType = response.data.study[0].type;
      const sessionMedia = response.data.study[0].media;

      if (sessionType == 'experience') {
        preferenceSession.remove();
      } else {
        experienceSession.remove();
      }

      if (sessionStarted) {
        const introComplete = response.data.surveys[0].is_completed;
        const currentTab = $('.w-tab-link.w--current');
        if (introComplete && currentTab.data('w-tab') === 'Tab 1') {
          $('.w-tab-link.w--current').next('.w-tab-link').trigger('click');
        }
        const sessionCompleted = response.data.study[0].user_ranking.completed;
        const surveySession = response.data.study[0].user_ranking.survey_session;

        // Audio playlist
        if (sessionMedia.length > 1) {
          playlist = true;
          tracks = sessionMedia;
        }

        /*



        Charting Experience Start




         */

        if (sessionType === 'experience') {
          // Charting application
          var chartClicks = 0;
          var startPoint = document.getElementById('startPoint');
          var endPoint = document.getElementById('endPoint');
          var finalPoint = document.getElementById('finalPoint');
          var svg = document.getElementById('chartLine');
          const chartResetButton = document.getElementById('chartReset');
          const chartStartButton = document.getElementById('chartStart');
          const chartConfirmButton = document.getElementById('chartConfirm');
          const chartLoading = document.getElementById('sessionXLoader');
          var sessionXContinue = $('[session-continue]');
          var sessionX = $('[wized=mit_XSource]');
          var sessionXAudio = $('[wized=mit_XAudioSource]');
          var currentlyPlaying = $('[wized=mit_currentPlaying]');
          var activeChartSession = false;
          var chartSessionCompleted = false;
          const gridWrapper = $('.charting_plus-grid');
          const sessionXWrapper = document.getElementById('sessionXCharting');
          var chartingData = {
            start: {
              val: null,
              aro: null,
              quad: null,
            },
            end: {
              val: null,
              aro: null,
              quad: null,
            },
            final: {
              val: null,
              aro: null,
              quad: null,
            },
            stimuli: {
              state: null,
              type: null,
              id: null,
              media: null,
            },
          };

          const chartingMapping = {
            perform: {
              matches: [
                ['5', '9', '2'],
                ['6', '9', '2'],
                ['7', '9', '2'],
                ['8', '9', '2'],
                ['9', '9', '2'],
                ['5', '8', '2'],
              ],
            },
            motivate: {
              matches: [
                ['6', '8', '2'],
                ['7', '8', '2'],
                ['8', '8', '2'],
                ['9', '8', '2'],
                ['5', '7', '2'],
                ['6', '7', '2'],
                ['7', '7', '2'],
              ],
            },
            create: {
              matches: [
                ['8', '7', '2'],
                ['9', '7', '2'],
                ['5', '6', '2'],
                ['6', '6', '2'],
                ['7', '6', '2'],
                ['8', '6', '2'],
                ['9', '6', '2'],
              ],
            },
            comfort: {
              matches: [
                ['5', '5', '2'],
                ['6', '5', '2'],
                ['7', '5', '2'],
                ['8', '5', '2'],
                ['9', '5', '2'],
                ['5', '5', '4'],
                ['6', '5', '4'],
                ['7', '5', '4'],
                ['8', '5', '4'],
                ['9', '5', '4'],
              ],
            },
            recover: {
              matches: [
                ['5', '4', '4'],
                ['6', '4', '4'],
                ['7', '4', '4'],
                ['8', '4', '4'],
                ['9', '4', '4'],
                ['8', '3', '4'],
                ['9', '3', '4'],
              ],
            },
            calm: {
              matches: [
                ['5', '3', '4'],
                ['6', '3', '4'],
                ['7', '3', '4'],
                ['6', '2', '4'],
                ['7', '2', '4'],
                ['8', '2', '4'],
                ['9', '2', '4'],
              ],
            },
            sleep: {
              matches: [
                ['5', '2', '4'],
                ['5', '1', '4'],
                ['6', '1', '4'],
                ['7', '1', '4'],
                ['8', '1', '4'],
                ['9', '1', '4'],
              ],
            },
          };

          // Hide all playlists
          function hidePlaylists() {
            $('.experience-playlist').each(function () {
              $(this).addClass('hide');
            });
          }

          hidePlaylists();

          function findMatchingParent(chartingData, chartingMapping) {
            // Extract val, aro, and quad from chartingData
            const { val, aro, quad } = chartingData.end; // or any other level (start, final) you want to check

            // Iterate over the chartingMapping object
            for (const parent in chartingMapping) {
              const matches = chartingMapping[parent].matches;

              // Check each match triple
              for (const match of matches) {
                if (match[0] === val && match[1] === aro && match[2] === quad) {
                  return parent; // Return the parent name if a match is found
                }
              }
            }
            return null; // Return null if no matches are found
          }

          function resetGrids() {
            if (chartSessionCompleted) {
              chartClicks = 2;
              finalPoint.style.display = 'none';
              chartResetButton.style.display = 'none';
              chartConfirmButton.style.display = 'none';
            } else {
              chartClicks = 0;
              svg.innerHTML = '';
              chartResetButton.style.display = 'none';
              chartStartButton.style.display = 'none';
              chartConfirmButton.style.display = 'none';
              startPoint.style.display = 'none';
              endPoint.style.display = 'none';
              $("[quad='1']").each(function () {
                $(this).css('pointer-events', 'auto');
              });
              $("[quad='3']").each(function () {
                $(this).css('pointer-events', 'auto');
              });
            }
          }

          function disableGrids() {
            $("[quad='1']").each(function () {
              $(this).css('pointer-events', 'none');
            });
            $("[quad='3']").each(function () {
              $(this).css('pointer-events', 'none');
            });
          }

          function showLoading() {
            chartLoading.style.display = 'flex';
            chartLoading.style.zIndex = '999';
            sessionXWrapper.style.display = 'none';
            setTimeout(function () {
              chartLoading.style.display = 'none';
            }, 3000);
          }

          async function loadPlaylists() {
            $(sessionXContinue).addClass('hide');
            $(currentlyPlaying).addClass('hide');
            activeChartSession = true;
            $(sessionXContinue).addClass('hide');
            const endState = findMatchingParent(chartingData, chartingMapping);
            chartingData.stimuli.state = endState;
            $('[wized=' + endState + '-playlist]').removeClass('hide');
            await Wized.data.setVariable('mit_activeChartSession', activeChartSession);
            $(sessionXAudio).addClass('hide');
          }

          async function loadChartSession(playlist) {
            //$(".immersive_content-layout").removeClass("is-block");
            hidePlaylists();
            if (!playlist) {
              $(sessionXAudio).addClass('hide');
              var src = sessionMedia[chartingData.end.quad - 1].src;
              var mediaID = sessionMedia[chartingData.end.quad - 1].id;
              await Wized.data.setVariable('active_media_id', mediaID);
            } else {
              await Wized.data.setVariable('mit_playlist_tracks', tracks);
              $(sessionX).addClass('hide');
              var src = tracks[0].src;
              $(currentlyPlaying).removeClass('hide');
            }
            var is_audio = src.includes('wav');
            var type = is_audio ? 'audio' : 'video';
            switch (type) {
              case 'audio':
                $(sessionXAudio).removeClass('hide');
                var x_audio = $(sessionXAudio).find('audio').first();
                x_audio[0].setAttribute('src', src);
                x_audio[0].load();
                x_audio[0].play();

                x_audio[0].addEventListener('ended', (event) => {
                  if (sessionMediaComplete) {
                    loadFinalGrid();
                    $(sessionXContinue).addClass('hide');
                  }
                });

                break;
              case 'video':
                var embed =
                  '<div class="wistia_responsive_padding" style="padding:56.25% 0 0 0;position:relative;"><div class="wistia_responsive_wrapper" style="height:100%;left:0;position:absolute;top:0;width:100%;"><span class="wistia_embed wistia_async_' +
                  src +
                  ' videoFoam=true playerColor=1f2120 popover=true popoverContent=thumbnail email=' +
                  sessionEmail +
                  ' popoverPreventScroll=true fullscreenButton=true playbackRateControl=false playbar=true playButton=true smallPlayButton=false qualityControl=false" style="display:inline-block;height:100%;position:relative;width:100%"></span></div></div>';
                //
                break;
              default:
                var embed = '';
            }
          }

          async function loadFinalGrid() {
            // Set active ID for surveys
            await Wized.data.setVariable('active_media_id', chartingData.stimuli.id);
            hidePlaylists();
            chartSessionCompleted = true;
            chartClicks = 2;
            startPoint.style.opacity = '0.10';
            endPoint.style.opacity = '0.10';
            sessionXWrapper.style.display = 'block';
            chartResetButton.style.display = 'none';
            chartStartButton.style.display = 'none';
            chartConfirmButton.style.display = 'none';
            $(sessionX).addClass('hide');
            $("[quad='1']").each(function () {
              $(this).css('pointer-events', 'auto');
            });
            $("[quad='3']").each(function () {
              $(this).css('pointer-events', 'auto');
            });
          }

          function drawLine() {
            svg.innerHTML = ''; // Clear previous lines
            var line = document.createElementNS('http://www.w3.org/2000/svg', 'line');
            line.setAttribute('x1', startPoint.style.left);
            line.setAttribute('y1', startPoint.style.top);
            line.setAttribute('x2', endPoint.style.left);
            line.setAttribute('y2', endPoint.style.top);
            line.setAttribute('stroke', '#E7E1D1');
            line.setAttribute('stroke-width', '2');
            svg.appendChild(line);
          }

          // Loop through grid points and set click event
          $('.charting_plus-grid-item').each(function () {
            $(this).on('click', async function (event) {
              // Increase Chart Click
              chartClicks++;
              // Get X and Y values for CSS
              if (event.currentTarget.parentElement.classList[0] === 'charting_plus-grid-split') {
                var parentRect =
                  event.currentTarget.parentElement.parentElement.getBoundingClientRect(); // Get parent div's position
              } else {
                var parentRect = event.currentTarget.parentElement.getBoundingClientRect(); // Get parent div's position
              }
              var x = event.clientX - parentRect.left; // Calculate relative x-coordinate
              var y = event.clientY - parentRect.top; // Calculate relative y-coordinate
              // Set Start points
              if (chartClicks == 1) {
                startPoint.style.display = 'block';
                startPoint.style.left = x + 'px';
                startPoint.style.top = y + 'px';
                startPoint.style.zIndex = '2';
                chartingData.start.val = $(this).attr('val');
                chartingData.start.aro = $(this).attr('aro');
                chartingData.start.quad = $(this).attr('quad');
                chartResetButton.style.display = 'block';
                disableGrids();
              }
              if (chartClicks == 2) {
                endPoint.style.display = 'block';
                endPoint.style.left = x + 'px';
                endPoint.style.top = y + 'px';
                endPoint.style.zIndex = '2';
                chartingData.end.val = $(this).attr('val');
                chartingData.end.aro = $(this).attr('aro');
                chartingData.end.quad = $(this).attr('quad');
                chartStartButton.style.display = 'block';
                drawLine();
                await Wized.data.setVariable('mit_chartingData', chartingData);
              }
              if (chartSessionCompleted && chartClicks == 3) {
                finalPoint.style.display = 'block';
                finalPoint.style.left = x + 'px';
                finalPoint.style.top = y + 'px';
                finalPoint.style.zIndex = '2';
                chartingData.final.val = $(this).attr('val');
                chartingData.final.aro = $(this).attr('aro');
                chartingData.final.quad = $(this).attr('quad');
                chartConfirmButton.style.display = 'block';
                chartResetButton.style.display = 'block';
              }
            });
          });

          $(chartResetButton).on('click', function (event) {
            resetGrids();
          });

          $(chartStartButton).on('click', function (event) {
            showLoading();
            loadPlaylists();
          });

          $('[wized=mit_sessionChartConfirm]').on('click', async function (event) {
            await Wized.data.setVariable('completedsession_step', true);
            await Wized.data.setVariable('mit_chartingData', chartingData);
            await Wized.request.execute('Add Charting'); // Trigger request
            chartResetButton.style.display = 'none';
            $(this).addClass('is-complete');
          });

          // Assign click events for playlists

          $('.session_component')
            .find('.audio-single-playlist_component')
            .each(function () {
              $(this).on('click', function () {
                //highlightTrack($(this));
                // Set playlist tracks
                chartingData.stimuli.id = $(this).attr('category');
                chartingData.stimuli.type = 'audio';
                chartingData.stimuli.media = JSON.parse($(this).attr('source'));
                // Audio playlist
                if (chartingData.stimuli.media.length > 1) {
                  playlist = true;
                  tracks = chartingData.stimuli.media;
                } else {
                  playlist = false;
                }
                loadChartSession(playlist);
              });
            });

          //

          _wq.push({
            id: '_all',
            onReady: function (media) {
              $(sessionXContinue).addClass('hide');
              media.bind('play', function () {
                chartingData.stimuli.id = 'wistia-' + media.hashedId();
                chartingData.stimuli.type = 'video';
                chartingData.stimuli.media = media.hashedId();
              });
              media.bind('end', function () {
                media.popover.hide();
                if (activeChartSession) {
                  loadFinalGrid();
                } else {
                  $(sessionXContinue).removeClass('hide');
                }
              });
            },
          });

          //

          // Init Reset
          resetGrids();
        } else {
          /*



        Charting Experience End




         */
          // None "experience" session
          // Assign video variables
          window._wq = window._wq || [];
          _wq.push({
            id: 'r463wdv5y8', // Video Intro Video
            onReady: function (intro) {
              // Hide intro button until video is watched
              //$("[wized=mit_sessionConfirm1]").addClass("hide");
              intro.bind('end', function () {
                intro.popover.hide();
                //$("[wized=mit_sessionConfirm1]").removeClass("hide");
              });
            },
          });

          _wq.push({
            id: '9dd9vic5so', // Audio Intro Video
            onReady: function (intro) {
              // Hide intro button until video is watched
              //$("[wized=mit_sessionConfirm1]").addClass("hide");
              intro.bind('end', function () {
                intro.popover.hide();
                //$("[wized=mit_sessionConfirm1]").removeClass("hide");
              });
            },
          });

          _wq.push({
            id: '_all',
            onReady: function (media) {
              var videoID = media.hashedId();
              if (
                videoID !== 'r463wdv5y8' ||
                videoID !== '41n4s5e8dt' ||
                videoID !== 'heh6dtg877'
              ) {
                var surveyButton = $('[video-id=' + videoID + ']');
                var surveyDisabled = $('[disabled-id=' + videoID + ']');
                $(surveyDisabled).removeClass('hide');
                $(surveyButton).addClass('hide');
                media.bind('end', function () {
                  media.popover.hide();
                  $(surveyDisabled).addClass('hide');
                  $(surveyButton).removeClass('hide');
                });
              }
            },
          });
        }

        if (!sessionCompleted && !surveySession) {
          $(sessionWindow).removeClass('hide');
        }
      }
    });

    Wized.data.listen('v.mit_control', async () => {
      const mitControl = await Wized.data.get('v.mit_control'); // Get new value
      const setTimer = timer(mitControl);
      async function timer(condition) {
        return await new Promise((resolve) => {
          if (mitControl) {
            var timer = 39;
            $('[wized=mit_mediaControlAction]').addClass('hide');
            $('[wized=mit_mediaControlTimer]').removeClass('hide');
            $('[wized=mit_mediaControlSeconds]').text(timer + 1 + ' seconds remaining');
            const interval = setInterval(() => {
              if (timer >= 1) {
                $('[wized=mit_mediaControlSeconds]').text(timer + ' seconds remaining');
                timer--;
              } else {
                //resolve("foo");
                clearInterval(interval);
                $('[wized=mit_mediaControlAction]').removeClass('hide');
                $('[wized=mit_mediaControlTimer]').addClass('hide');
              }
            }, 1000);
          }
        });
      }
    });

    $('[wized=mit_start]').on('click', function () {
      $(sessionWindow).removeClass('hide');
      document.getElementById('session').scrollIntoView({ behavior: 'smooth' });
    });

    $('#continue').on('click', async function () {
      $('.w-tab-link.w--current').next('.w-tab-link').trigger('click');
    });

    $('[wized=mit_continueR1Step], [wized=mit_continueR2Step], [wized=mit_continueR3Step]').on(
      'click',
      async function () {
        $('.w-tab-link.w--current').next('.w-tab-link').trigger('click');
      }
    );

    Wized.request.await('Get MIT Session', (response) => {
      function delayedAction() {
        window.Webflow && window.Webflow.destroy();
        window.Webflow && window.Webflow.ready();
        window.Webflow && window.Webflow.require('ix2').init();
        document.dispatchEvent(new Event('readystatechange'));
        iframeSetup();
        response.data.study[0].type != 'experience' ? sortableSetup() : false;
        const players = Array.from(document.querySelectorAll('.js-player')).map(
          (p) =>
            new Plyr(p, {
              controls: ['play', 'progress', 'current-time'],
            })
        );
        $('audio').each(function () {
          var audioID = this.src;
          var audioSurveyButton = $("[video-id='" + audioID + "']");
          var audioSurveyDisabled = $("[disabled-id='" + audioID + "']");
          var sessionContinue = $('[session-continue]');
          $(sessionContinue).addClass('hide');
          $(audioSurveyDisabled).removeClass('hide');
          $(audioSurveyButton).addClass('hide');
          this.addEventListener('ended', (event) => {
            var advance = nextTrack(this);
            advance.then((value) => {
              if (!value) {
                $(audioSurveyDisabled).addClass('hide');
                $(audioSurveyButton).removeClass('hide');
                $(sessionContinue).removeClass('hide');
              }
            });
          });
          this.addEventListener('timeupdate', () => {
            if (!isTrackPlayedLogged && this.currentTime / this.duration >= 0.01) {
              isTrackPlayedLogged = true;
              // Send a POST request to your custom API
              fetch('https://xpzx-vpjp-v6yl.n7.xano.io/api:EDVUqmEk/media_log', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  // Add any additional headers if needed
                },
                body: JSON.stringify({
                  media_url: tracks[track].src,
                  media_id: tracks[track].ISRC,
                }),
              })
                .then((response) => {
                  if (response.ok) {
                  } else {
                    //  console.error('Failed to log track play');
                  }
                })
                .catch((error) => {
                  // console.error('Error logging track play:', error);
                });
            }
          });
        });
      }
      setTimeout(delayedAction, 100);
    });
  }

  async function nextTrack(audioPlayer) {
    if (playlist == true && track + 1 != tracks.length) {
      track++;
      await Wized.data.setVariable('mit_playlistIndex', track);
      audioPlayer.pause();
      audioPlayer.currentTime = 0;
      audioPlayer.setAttribute('src', tracks[track].src);
      isTrackPlayedLogged = false;
      audioPlayer.load();
      audioPlayer.play();
      return true;
    } else {
      audioPlayer.setAttribute('src', '');
      sessionMediaComplete = true;
      // audioPlayer.load();
      $('[wized=mit_XAudioSource]').addClass('hide');
      $('[wized=mit_currentPlaying]').addClass('hide');
      return false;
    }
  }

  function sortableSetup() {
    // Define
    var sortableOne = document.getElementById('sortableOne');
    var sortableOneRank = document.getElementById('sortableOneRank');
    var sortableTwo = document.getElementById('sortableTwo');
    var sortableTwoRank = document.getElementById('sortableTwoRank');
    var sortableThree = document.getElementById('sortableThree');
    var sortableThreeRank = document.getElementById('sortableThreeRank');
    var sortableAllA = document.getElementById('sortableAllA');
    var sortableAllB = document.getElementById('sortableAllB');
    $('[wized=mit_sessionRankConfirm1]').hide();
    $('[wized=mit_sessionRankConfirm2]').hide();
    $('[wized=mit_sessionRankConfirm3]').hide();
    new Sortable(sortableOne, {
      group: {
        name: 'sharedOne',
        put: false, // Do not allow items to be put into this list
      },
      animation: 200,
      easing: 'cubic-bezier(1, 0, 0, 1)',
      dataIdAttr: 'data-rank',
      draggable: '.sortable_list-item',
      dragClass: 'sortable-drag',
      forceFallback: true,
      sort: false, // To disable sorting: set sort to false
    });
    new Sortable.create(sortableOneRank, {
      group: 'sharedOne',
      animation: 200,
      easing: 'cubic-bezier(1, 0, 0, 1)',
      dataIdAttr: 'data-rank',
      draggable: '.sortable_list-item',
      dragClass: 'sortable-drag',
      forceFallback: true,
      store: {
        set: async function (sortable) {
          var order = sortable.toArray();
          if (order.length == 3) {
            $('[wized=mit_sessionRankConfirm1]').show();
          }
          await Wized.data.setVariable('stack_rank_one', order);
        },
      },
    });
    new Sortable(sortableTwo, {
      group: {
        name: 'sharedTwo',
        put: false, // Do not allow items to be put into this list
      },
      animation: 200,
      easing: 'cubic-bezier(1, 0, 0, 1)',
      dataIdAttr: 'data-rank',
      draggable: '.sortable_list-item',
      dragClass: 'sortable-drag',
      forceFallback: true,
      sort: false, // To disable sorting: set sort to false
    });
    new Sortable.create(sortableTwoRank, {
      group: 'sharedTwo',
      animation: 200,
      easing: 'cubic-bezier(1, 0, 0, 1)',
      dataIdAttr: 'data-rank',
      draggable: '.sortable_list-item',
      dragClass: 'sortable-drag',
      forceFallback: true,
      store: {
        set: async function (sortable) {
          var order = sortable.toArray();
          if (order.length == 3) {
            $('[wized=mit_sessionRankConfirm2]').show();
          }
          await Wized.data.setVariable('stack_rank_two', order);
        },
      },
    });
    new Sortable(sortableThree, {
      group: {
        name: 'sharedThree',
        put: false, // Do not allow items to be put into this list
      },
      animation: 200,
      easing: 'cubic-bezier(1, 0, 0, 1)',
      dataIdAttr: 'data-rank',
      draggable: '.sortable_list-item',
      dragClass: 'sortable-drag',
      forceFallback: true,
      sort: false, // To disable sorting: set sort to false
    });
    new Sortable.create(sortableThreeRank, {
      group: 'sharedThree',
      animation: 200,
      easing: 'cubic-bezier(1, 0, 0, 1)',
      dataIdAttr: 'data-rank',
      draggable: '.sortable_list-item',
      dragClass: 'sortable-drag',
      forceFallback: true,
      store: {
        set: async function (sortable) {
          var order = sortable.toArray();
          if (order.length == 3) {
            $('[wized=mit_sessionRankConfirm3]').show();
          }
          await Wized.data.setVariable('stack_rank_three', order);
        },
      },
    });

    new Sortable(sortableAllA, {
      group: {
        name: 'sharedAll',
        //pull: 'clone',
        put: false, // Do not allow items to be put into this list
      },
      animation: 200,
      easing: 'cubic-bezier(1, 0, 0, 1)',
      dataIdAttr: 'data-rank',
      draggable: '.sortable_list-item',
      dragClass: 'sortable-drag',
      forceFallback: true,
      sort: false, // To disable sorting: set sort to false
    });

    new Sortable(sortableAllB, {
      group: 'sharedAll',
      animation: 200,
      easing: 'cubic-bezier(1, 0, 0, 1)',
      dataIdAttr: 'data-rank',
      draggable: '.sortable_list-item',
      dragClass: 'sortable-drag',
      forceFallback: true,
      store: {
        set: async function (sortable) {
          var order = sortable.toArray();
          await Wized.data.setVariable('stack_rank_all', order);
        },
      },
    });
  }

  function iframeSetup() {
    var url = undefined;
    var srcUrl = undefined;
    var iframe = undefined;
    var completeBtn = undefined;
    var contentWrapper = undefined;
    $('[data-embed-url]').each(function () {
      // Reset iframe src
      $(this).siblings('.modal1_component').find('.modal1_embed iframe').attr('src', '');
      $(this).on('click', function () {
        url = $(this).data('embed-url');
        iframe = $(this).siblings('.modal1_component').find('.modal1_embed iframe');
        srcUrl = iframe.attr('src');
        completeBtn = $(this)
          .siblings('.modal1_component')
          .find('.modal1_content-wrapper .button')[0];
        contentWrapper = $(this).siblings('.modal1_component').find('.modal1_content-wrapper')[0];
        completeBtn.style.display = 'none';
        if (srcUrl === '') {
          iframe.attr('src', url);

          function setIframeSize(data, iframe) {
            if (data.zohosurvey) {
              if (data.zohosurvey.action == 'surveySize') {
                iframe.style.height = data.zohosurvey.height - 75 + 'px';
                contentWrapper.scrollTo(0, 0);
              } else if (data.zohosurvey.action == 'moveScroll') {
                contentWrapper.scrollTo(0, data.zohosurvey.position);
              }
            }
          }
          window.addEventListener(
            'message',
            function (e) {
              setIframeSize(e.data, iframe[0]);
              if (e.data && e.data['zohosurvey_respondentStatus'] === 'completed') {
                completeBtn.style.display = 'flex';
              }
            },
            false
          );
        }
      });
    });
  }

  const token = await Wized.data.get('c.token');
  Wized.request.await('Load user', (response) => {
    //cosole.log(token);
    if (token !== undefined || token !== '' || token !== null) {
      $('.user-loader').addClass('hide');
    }
  });

  Wized.request.await('Get 2.1 Questionnaires', (response) => {
    function delayedAction() {
      window.Webflow && window.Webflow.destroy();
      window.Webflow && window.Webflow.ready();
      window.Webflow && window.Webflow.require('ix2').init();
      document.dispatchEvent(new Event('readystatechange'));
      iframeSetup();
    }
    setTimeout(delayedAction, 100);
  });
  Wized.request.await('Get 4.2 Questionnaires', (response) => {
    function delayedAction() {
      window.Webflow && window.Webflow.destroy();
      window.Webflow && window.Webflow.ready();
      window.Webflow && window.Webflow.require('ix2').init();
      document.dispatchEvent(new Event('readystatechange'));
      iframeSetup();
    }
    setTimeout(delayedAction, 100);
  });
  Wized.request.await('Get Session End Questions', (response) => {
    function delayedAction() {
      window.Webflow && window.Webflow.destroy();
      window.Webflow && window.Webflow.ready();
      window.Webflow && window.Webflow.require('ix2').init();
      document.dispatchEvent(new Event('readystatechange'));
      iframeSetup();
    }
    setTimeout(delayedAction, 100);
  });

  Wized.request.await('Load study', (response) => {
    function delayedAction() {
      document.querySelector('audio').load();
    }
    setTimeout(delayedAction, 100);
  });

  Wized.request.await('Get Session Questions', (response) => {
    iframeSetup();
  });

  Wized.request.await('Get 2.2.4 Questionnaires', (response) => {
    iframeSetup();
  });

  Wized.request.await('Get Session End Questions', (response) => {
    iframeSetup();
  });
};
